<template>
  <div id="balloon-container">
    <!-- <div>
      <div class="col s12 m2 l2">
        <a class="waves-effect waves-light btn white" @click="launch">L</a>
      </div>
      <div class="col s12 m2 l2">
        <a class="waves-effect waves-light btn white" @click="stop">X</a>
      </div>
    </div>-->
    <div id="book"></div>
    <div class="container" style="padding-top:30px">
      &nbsp;&nbsp;&nbsp;
      <div class="row">
        <div class="col s12 m6 l6">
          <a
            class="waves-effect waves-light btn teal darken-4"
            href="Class_VII_Science_Term_1_CBQ_Based_Questions.pdf"
          >
            <!-- <i class="material-icons right">get_app</i> -->
            DOWNLOAD PDF
          </a>
        </div>
        <!-- <div class="col s12 m6 l6">
          <a class="waves-effect waves-light btn modal-trigger teal darken-4" href="#modal1">
            <i class="material-icons right">menu</i>CONTENTS
          </a>
        </div>-->
      </div>
    </div>
    <div id="modal1" class="modal">
      <div class="modal-content">
        <table class="striped highlight">
          <thead>
            <tr>
              <td>
                <b>Science Projects</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(link,i) in page_links" :key="i">
              <td @click="gotoPage(link.page)" style="cursor:pointer">
                {{link.link_text}}
                <!-- <a class="waves-effect" href="#!">{{link.link_text}}</a> -->
              </td>
            </tr>
          </tbody>
        </table>
        <table class="striped highlight">
          <thead>
            <tr>
              <td>
                <b>Math Projects</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(link,i) in page_links2" :key="i+80">
              <td @click="gotoPage(link.page)" style="cursor:pointer">{{link.link_text}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat">CLOSE</a>
      </div>
    </div>
  </div>
</template>

<script>
import { PageFlip } from "page-flip";
import "materialize-css/dist/css/materialize.min.css";
import "materialize-css/dist/js/materialize.min";
import { isMobile } from "mobile-device-detect";
export default {
  data() {
    return {
      pages: [],
      pageFlip: null,
      message: isMobile ? "Mobile Browser" : "Laptop Browser",
      elems2: null,
      instances2: null,
      page_links: [
        {
          link_text: "Archimedes' principle",
          page: 11
        },
        {
          link_text: "Study of a efflux of a liquid based on Torricelli’s law",
          page: 23
        },
        {
          link_text: "Verification of Pascal’s law in a hydraulic system",
          page: 29
        },
        {
          link_text: "Test the purity of milk by viscosity phenomena",
          page: 36
        },
        {
          link_text: "Dancing raisins in a carbonated soft drink",
          page: 42
        },
        {
          link_text: "Circle of illuminance ",
          page: 46
        },
        {
          link_text: "Conductivity of liquids",
          page: 53
        },
        {
          link_text: "Study of magnetic field in and around a solenoid ",
          page: 58
        },
        {
          link_text: "Wireless electric field supply with a mini Tesla coil",
          page: 66
        },
        {
          link_text: "Basic logic gates",
          page: 73
        },
        {
          link_text:
            "Variation of temporary hardness of water with temperature",
          page: 84
        },
        {
          link_text: "Dyeing fabrics with natural dyes",
          page: 92
        },
        {
          link_text: "Foaming and cleansing action of soap",
          page: 99
        },
        {
          link_text: "Natural hand wash",
          page: 106
        },
        {
          link_text:
            "Separation of photosynthetic pigments from leaves of gram plant",
          page: 112
        },
        {
          link_text:
            "Rate of photosynthesis in Hydrilla plant for different wavelengths of light",
          page: 119
        },
        {
          link_text:
            "Diversity of trees and its effect of trees on the ambient temperature ",
          page: 124
        },
        {
          link_text:
            "Morphology of different mammalian pinnae and its effect on sound collection",
          page: 130
        },
        {
          link_text: "A study of antibacterial property of garlic in curd ",
          page: 136
        },
        {
          link_text: "Carbon footprint estimate of households in a locality",
          page: 141
        },
        {
          link_text:
            "Model of Lac operon in the presence and absence of lactose in the medium",
          page: 147
        },
        {
          link_text:
            "A comparative study of BMI of women and men in a locality ",
          page: 152
        },
        {
          link_text: "Model of cloning vector pBR322 showing restriction sites",
          page: 158
        },
        {
          link_text:
            "Model of basic steps of making recombinant DNA by action of EcoR1",
          page: 163
        }
      ],
      page_links2: [
        {
          link_text: "Three-dimensional co-ordinate system",
          page: 169
        },
        {
          link_text: "Signs of trigonometric function",
          page: 174
        },
        {
          link_text:
            "Values of sine and cosine functions for angle multiples of pi and pi/2",
          page: 178
        },
        {
          link_text: "Construction of a parabola ",
          page: 183
        },
        {
          link_text:
            "Relation between A.M and G.M of any two positive real numbers",
          page: 187
        },
        {
          link_text: "Geometrical significance of a derivative",
          page: 191
        },
        {
          link_text: "Verification of Rolle’s theorem",
          page: 195
        },
        {
          link_text: "Verification of infinite geometric series",
          page: 199
        },
        {
          link_text: "Exponential functions",
          page: 203
        },
        {
          link_text: "References",
          page: 207
        }
      ]
      // instances:null
    };
  },
  mounted() {
    this.pageFlip = new PageFlip(document.getElementById("book"), {
      width: isMobile ? 480 : 600,
      height: isMobile ? 640 : 800,
      // width: 600,
      // height: 800,
      drawShadow: true,
      //startZIndex: 3,
      showCover: true
      // startPage: 1
      //  size: stretch
    });
    //console.log(document.getElementById("book"));
    // pageFlip.loadFromHTML(document.querySelectorAll('.my-page'));

    // for (var i = 2; i < 12; i++) {
    // this.pages.push("img/page (a).jpg");
    // }
    for (var j = 0; j < 121; j++) {
      this.pages.push("1/page (" + j + ").jpg");
      // console.log("img/page (" + j + ").jpg");
    }
    // console.log(pages);
    this.pageFlip.loadFromImages(this.pages);
    this.elems2 = document.querySelectorAll(".modal");
    this.instances2 = M.Modal.init(this.elems2, {});
    // var elems = document.querySelectorAll(".sidenav");
    // var instances = M.Sidenav.init(elems, {});

    // document.getElementsByClassName("sidenav").sidenav();
    // console.log(M.Sidenav.init);
    //console.log(elems);
    // document.addEventListener("DOMContentLoaded", function(e) {
    //   document.querySelectorAll(".sidenav").sidenav();
    // });
    // const canva = document.getElementsByClassName("stf__canvas");
    // canva.width = 700;
    // canva.height = 900;
  },
  created() {},
  methods: {
    launch() {
      this.createBalloons(50);
    },
    stop() {
      var balloonss = document.getElementsByClassName("balloon");
      while (balloonss.length > 0) {
        balloonss[0].parentNode.removeChild(balloonss[0]);
      }
    },
    gotoPage(page_number) {
      console.log(page_number);
      this.pageFlip.turnToPage(page_number);
      // this.instances2.close();
    },
    createBalloons(num) {
      var balloonContainer = document.getElementById("balloon-container");
      for (var i = num; i > 0; i--) {
        var balloon = document.createElement("div");
        balloon.className = "balloon";
        balloon.style.cssText = this.getRandomStyles();
        balloonContainer.append(balloon);
      }
    },
    getRandomStyles() {
      var r = this.random(255);
      var g = this.random(255);
      var b = this.random(255);
      var mt = this.random(200);
      var ml = this.random(50);
      var dur = this.random(5) + 5;
      return `
  background-color: rgba(${r},${g},${b},0.7);
  color: rgba(${r},${g},${b},0.7); 
  box-shadow: inset -7px -3px 10px rgba(${r - 10},${g - 10},${b - 10},0.7);
  margin: ${mt}px 0 0 ${ml}px;
  animation: float ${dur}s ease-in infinite
  `;
    },
    random(num) {
      return Math.floor(Math.random() * num);
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}
#book {
  margin: auto;
  width: 80%;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#balloon-container {
  /* height: 100vh; */
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}

.balloon {
  height: 125px;
  width: 105px;
  border-radius: 75% 75% 70% 70%;
  position: relative;
}

.balloon:before {
  content: "";
  height: 75px;
  width: 1px;
  padding: 1px;
  background-color: #fdfd96;
  display: block;
  position: absolute;
  top: 125px;
  left: 0;
  right: 0;
  margin: auto;
}

.balloon:after {
  content: "▲";
  text-align: center;
  display: block;
  position: absolute;
  color: inherit;
  top: 120px;
  left: 0;
  right: 0;
  margin: auto;
}

@keyframes float {
  from {
    transform: translateY(100vh);
    opacity: 1;
  }
  to {
    transform: translateY(-300vh);
    opacity: 0;
  }
}
</style>
